import { OptionCard, StepBody, StepHeader, StepNav } from "./AiboxWizardParts";

const AiboxStepLiveView = ({ channels, selectedLiveViewChannels, setSelectedLiveViewChannels, onNext, onBack, isLastStep }) => {
    const toggle = (no) => {
        setSelectedLiveViewChannels(prev => prev.includes(no) ? prev.filter(x => x !== no) : [...prev, no]);
    };

    return (
        <>
            <StepHeader title="Which channels would you like to stream?" subtitle="Selected channels will be available for live viewing" />
            <StepBody>
                {channels.length === 0 && (
                    <p style={{ color: "var(--text-label)", fontSize: "14px", textAlign: "center", marginTop: "2rem" }}>
                        No channels were found on this AiBox.
                    </p>
                )}
                {channels.map(channel => (
                    <OptionCard
                        key={channel.no}
                        title={channel.name}
                        subtitle={`Channel ${channel.no}`}
                        selected={selectedLiveViewChannels.includes(channel.no)}
                        onClick={() => toggle(channel.no)}
                    />
                ))}
            </StepBody>
            <StepNav
                onBack={onBack}
                onNext={onNext}
                nextDisabled={selectedLiveViewChannels.length === 0}
                nextLabel={isLastStep ? "Link AiBox" : "Next"}
                nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
            />
        </>
    );
};

export default AiboxStepLiveView;
